/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TCreateActionCheckModel,
  ICreateActionCheckRequest,
  IMappers,
  ICreateActionCheckResponse,
  ICreateActionCheckResponseError,
  TCreateActionCheckResponse,
} from './types';

const defaultConfig: TCreateActionCheckModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'moderation-action-check',
  pathApi: '/v1/create-action-check/',
  hostType: 'api',
  responseType: 'json',
} as TCreateActionCheckModel;

function createCreateActionCheckModel(parameters: ICreateActionCheckRequest): TCreateActionCheckModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICreateActionCheckOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ICreateActionCheckRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchCreateActionCheck<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ICreateActionCheckOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TCreateActionCheckResponse
> {
  const { response, statusCode } = await httpApi.fetch(createCreateActionCheckModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICreateActionCheckResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ICreateActionCheckResponseError);
    }
  }

  return { response, statusCode } as TCreateActionCheckResponse;
}

export { defaultConfig, createCreateActionCheckModel, fetchCreateActionCheck };
